// src/pages/product/ProductCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Product creation now
// happens through ProductCreateDialog (form-kit), opened from
// ProductListPage's "+ New" — see docs/ux/14-forms.md. This route just
// sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ProductCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/products', { replace: true });
  }, [navigate]);
  return null;
};

export default ProductCreatePage;
